import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sp-radio"
    }}>{`sp-radio`}</h1>
    <p><strong parentName="p">{`Since:`}</strong>{` UXP v4.1`}</p>
    <p>{`Renders a radio button with associated label.`}</p>
    <p><img alt="Radio groups" src={require("../../assets/sp-radio.png")} /></p>
    <p><strong parentName="p">{`See`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://spectrum.adobe.com/page/radio-button/"
        }}>{`https://spectrum.adobe.com/page/radio-button/`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://opensource.adobe.com/spectrum-web-components/components/radio"
        }}>{`https://opensource.adobe.com/spectrum-web-components/components/radio`}</a></li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-radio value="ps">Adobe Photoshop</sp-radio>
`}</code></pre>
    <h2 {...{
      "id": "variants-and-states"
    }}>{`Variants and states`}</h2>
    <p>{`There are several different variants and states for radio buttons.`}</p>
    <h3 {...{
      "id": "checked"
    }}>{`Checked`}</h3>
    <p>{`Indicates that the radio button is selected.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-radio checked value="ps">Adobe Photoshop</sp-radio>
`}</code></pre>
    <h3 {...{
      "id": "disabled"
    }}>{`Disabled`}</h3>
    <p>{`Indicates that the radio button is disabled.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-radio disabled value="ps">Adobe Photoshop</sp-radio>
`}</code></pre>
    <h3 {...{
      "id": "invalid"
    }}>{`Invalid`}</h3>
    <p>{`Indicates that the radio button selection is invalid.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-radio invalid value="ps">Adobe Photoshop</sp-radio>
`}</code></pre>
    <h3 {...{
      "id": "emphasized"
    }}>{`Emphasized`}</h3>
    <p>{`Indicates that the radio button selection is emphasized.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-radio emphasized value="ps">Adobe Photoshop</sp-radio>
`}</code></pre>
    <h2 {...{
      "id": "responding-to-events"
    }}>{`Responding to events`}</h2>
    <p>{`You can respond to clicks on the radio button using the `}<inlineCode parentName="p">{`click`}</inlineCode>{` event.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`document.querySelector(".yourRadioButton").addEventListener("click", evt => {
    console.log(\`You clicked: \${evt.target.value}\`);
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      